export default __webpack_public_path__ + "static/keyFeatureBackground-53bcbdc602fffe50d6e670e10902440a.png";